import DesktopVendor from './DesktopVendor.component';

export default DesktopVendor;
